/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_user" | "SbSharedRefineMenuFilters_user" | "SbSharedRefineMenuDisplayPrefsSelect_user">;
    readonly " $refType": "SbRespRefineMenu_user";
};
export type SbRespRefineMenu_user$data = SbRespRefineMenu_user;
export type SbRespRefineMenu_user$key = {
    readonly " $data"?: SbRespRefineMenu_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_user",
      "args": null
    }
  ]
};
(node as any).hash = '74ebce40e67e74dec2659a58bcf480b0';
export default node;
